var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3635_707)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36.4495,
    r: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3635_707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6 33.2367C33.72 33.2367 33 33.9117 33 34.7367V38.4867C33 38.901 32.642 39.2367 32.2 39.2367C31.758 39.2367 31.4 38.901 31.4 38.4867V34.8984C31.4 34.0832 31.636 33.2826 32.0845 32.5832L35.972 26.5087C36.4265 25.7981 36.1815 24.877 35.4235 24.4504C34.701 24.044 33.7875 24.2488 33.3085 24.8821C33.2985 24.8929 33.2775 24.892 33.269 24.9046L27.406 33.1499C26.878 33.8924 26.6 34.7554 26.6 35.6451V39.4059L22.094 40.814C21.7754 40.9134 21.4982 41.1043 21.3019 41.3597C21.1055 41.615 20.9999 41.9219 21 42.2367V46.7367C21 47.2438 21.426 48.2367 22.6 48.2367C22.7345 48.2367 22.8705 48.2207 23.003 48.1884L31.9625 46.0031C34.458 45.3342 36.2 43.169 36.2 40.7367V34.7367C36.2 33.9117 35.48 33.2367 34.6 33.2367ZM51.906 40.8178L47.4 39.4096V35.6488C47.4 34.7592 47.122 33.8962 46.594 33.1537L40.731 24.9088C40.722 24.8962 40.7015 24.8976 40.6915 24.8863C40.2125 24.2531 39.299 24.0482 38.5765 24.4546C37.8185 24.8807 37.5735 25.8023 38.028 26.5129L41.9155 32.5874C42.364 33.2868 42.6 34.0874 42.6 34.9026V38.4909C42.6 38.9053 42.242 39.2409 41.8 39.2409C41.358 39.2409 41 38.9053 41 38.4909V34.7409C41 33.9159 40.28 33.2409 39.4 33.2409C38.52 33.2409 37.8 33.9159 37.8 34.7409V40.7409C37.8 43.1732 39.542 45.3384 42.0375 46.0068L50.997 48.1921C51.13 48.2245 51.266 48.2404 51.4 48.2404C52.574 48.2404 53 47.2476 53 46.7404V42.2404C53 41.5949 52.5595 41.0221 51.906 40.8178Z",
    fill: "#ED8842"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3635_707",
    x: 0.8,
    y: 0.249463,
    width: 72.4,
    height: 72.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.269963 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3635_707"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3635_707",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3635_707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(18 17.4495)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4);
export default __webpack_public_path__ + "static/media/step4.8cda4736e8825bc25d728fb0a2d17674.svg";
export { ForwardRef as ReactComponent };